import utils from '@utils';

export const create = async () => {
  const res = await utils.axios.slsGo().post(`/teams`);

  return res.data;
};

export const leave = async (id: number) => {
  const res = await utils.axios.slsGo().delete(`/teams/${id}`);

  return res.data;
};

export const getOne = async (id: number) => {
  const res = await utils.axios.slsGo().get(`/teams/${id}`);

  return res.data;
};

export const update = async (id: number, b: any) => {
  const res = await utils.axios.slsGo().put(`/teams/${id}`, b);

  return res.data;
};
